import React from 'react';

import { colors, fonts, container, eyebrow, sectionHeading } from '../theme';
import { howSteps } from '../data';

export default function HowItWorks() {
  return (
    <section id="how" className="lyfe-wrap lyfe-sec" style={{ ...container, padding: '130px 40px 120px' }}>
      <div className="lyfe-reveal" style={{ maxWidth: 640, marginBottom: 80 }}>
        <div style={eyebrow(colors.blue)}>How it works</div>
        <h2 className="lyfe-h2" style={sectionHeading}>
          It's never too late
          <br />
          to start the night.
        </h2>
      </div>
      <div
        className="lyfe-g3"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3,1fr)',
          gap: 1,
          background: 'rgba(255,255,255,.08)',
          border: '1px solid rgba(255,255,255,.08)',
        }}>
        {howSteps.map((s) => (
          <div key={s.n} className="lyfe-reveal" style={{ background: colors.bg, padding: '48px 40px' }}>
            <div style={{ fontFamily: fonts.serif, fontSize: 52, color: colors.indigo, lineHeight: 1 }}>{s.n}</div>
            <h3 style={{ fontSize: 23, fontWeight: 600, marginTop: 28 }}>{s.title}</h3>
            <p style={{ fontSize: 16, lineHeight: 1.6, color: colors.muted2, marginTop: 14 }}>{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
